module.exports = __webpack_public_path__ + "static/media/background-auto.d05673d5.svg";